import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { FEATURED_IMAGE } from "../../Public/constants";
import { useFirebase } from "../../Context/FirebaseContext";
import { useEffect, useState } from "react";

const BlogsCard = ({ el, month, date, year }) => {
  const navigate = useNavigate();
  const firebase = useFirebase();
  const [url, setUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (el?.featuredImage?.includes("upload")) {
      firebase.getImageUrl(el?.featuredImage).then((url) => {
        setUrl(url);
        setIsLoading(false);
      });
    } else {
      setUrl(FEATURED_IMAGE);
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      <div
        key={el._id}
        className="cursor-pointer"
        onClick={() => navigate(`/blogs/${el._id}`)}
      >
        <div className="relative h-60">
          {isLoading ? (
            <div className="animate-pulse bg-gray-300 dark:bg-gray-700 rounded h-60 w-full"></div>
          ) : (
            <img
              className="object-cover rounded h-full w-full"
              alt="featured"
              src={url}
            />
          )}
        </div>
        <h2 className="tracking-widest text-xs font-bold text-indigo-500 mb-1">
          {el.categories.map((el) => el.name + " | ")}
        </h2>
        <h1 className="title-font text-xl font-bold capitalize text-gray-900 dark:text-white mb-3">
          {el.title}
        </h1>
        <div className="leading-relaxed text-sm capitalize mb-5 dark:text-gray-300">
          {parse(el.body.slice(0, 145))}
        </div>
        <div className="flex gap-2 items-center">
          <img
            alt="blog"
            src={el.user?.avatar}
            className="w-7 h-7 rounded-full flex-shrink-0 object-cover object-center"
          />

          <span className="title-font font-medium text-sm text-gray-900 dark:text-white capitalize">
            {el.user.name}
          </span>
          <span className="text-xl">•</span>
          <p className="text-sm">
            {date}&nbsp;
            {month}&nbsp;
            {year}
          </p>
        </div>
      </div>
    </>
  );
};

export default BlogsCard;
